module.exports = __webpack_public_path__ + "img/share.7a816f48.png";